export const TRANSLATION_STATUS = {
  DRAFT: 'draft',
  READY: 'ready',
  NEEDS_REVIEW: 'needs_review',
} as const

export type TranslationStatusType = (typeof TRANSLATION_STATUS)[keyof typeof TRANSLATION_STATUS]

export const TRANSLATION_STATUS_COLORS: Record<TranslationStatusType, string> = {
  draft: 'orange',
  ready: 'green',
  needs_review: 'red',
}

export const ReasonType = {
  TRANSLATE_AUDIO_AVAILABLE: true,
  TRANSLATE_AUDIO_NOT_AVAILABLE: false,
}
